import { combineReducers } from 'redux'

import resultados from './despesasPorUnidade'

export default combineReducers({ resultados })
